import { render, staticRenderFns } from "./VOCHistory.vue?vue&type=template&id=2acf5937&scoped=true&"
import script from "./VOCHistory.vue?vue&type=script&lang=js&"
export * from "./VOCHistory.vue?vue&type=script&lang=js&"
import style0 from "./VOCHistory.vue?vue&type=style&index=0&id=2acf5937&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acf5937",
  null
  
)

export default component.exports